<template>
  <tr>
    <td data-label="Staff Name">
      {{ staffTaxInvoiceReport.StaffMemberFullName }}
    </td>
    <td data-label="Date">
      {{ staffTaxInvoiceReport.createdAt | formatDate}}
    </td>
    <td data-label="Invoice Quote">
      {{ staffTaxInvoiceReport.quoteNumber }}
    </td>
    <td data-label="Invoice Amount">
      {{ staffTaxInvoiceReport.invoiceAmount }}
    </td>
    <td data-label="Nature of Work">
      {{ staffTaxInvoiceReport.natureOfWorks }}
    </td>
    <td data-label="Property Address">
      {{ staffTaxInvoiceReport.propertyAddress }}
    </td>
    <td data-label="Total Invoice Number">
      {{ staffTaxInvoiceReport.TotalInvoiceCount }}
    </td>
    <td data-label="Total Invoice Amount">
      {{ staffTaxInvoiceReport.TotalInvoiceAmount }}
    </td>
  </tr>
</template>

<script>
export default {
  name: 'StaffTaxInvoiceReportRow',
  props: {
    object: {
      type: Object,
    },
    index: {
      type: Number
    }
  },
  computed: {
    staffTaxInvoiceReport () {
      return {
        ...this.object
      }
    }
  },
  filters: {
    formatDate(value) {
      const options = {
          day: 'numeric',
          month: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false
      }
      return value ? new Date(value).toLocaleString("en-AU", options) : '';
      // return value ? new Date(value).toLocaleString(undefined, { timeZone: 'UTC' }) : '';

    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/rows/StaffTaxInvoiceReport.vue